export const RADIAN = Math.PI / 180;
